<section class="document-analysis">
  <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>

  <header class="document-analysis__header">
    <h1 class="document-analysis__title">Análise de documentos</h1>
    <p class="document-analysis__subtitle">
      Somente empresas com documentos pendentes de análise. Quando a última pendência é resolvida, a
      empresa sai desta tela.
    </p>
  </header>

  <app-document-analysis-summary [totals]="totals()"></app-document-analysis-summary>

  <app-document-analysis-toolbar
    [companiesCount]="filtered().length"
    [viewMode]="viewMode()"
    (searchChange)="handleSearch($event)"
    (viewModeChange)="handleViewMode($event)"></app-document-analysis-toolbar>

  @if (isEmpty()) {
    <p class="document-analysis__empty">Nenhuma empresa com documentos pendentes de análise.</p>
  } @else if (hasNoSearchResult()) {
    <p class="document-analysis__empty">Nenhuma empresa encontrada para essa busca.</p>
  } @else if (viewMode() === 'table') {
    <app-document-analysis-table
      [rows]="filtered()"
      [loading]="!isLoaded()"
      (analyze)="handleAnalyze($event)"></app-document-analysis-table>
  } @else {
    <app-document-analysis-cards
      [rows]="filtered()"
      (analyze)="handleAnalyze($event)"></app-document-analysis-cards>
  }
</section>
